export const weekdayEN = [
  { id: 0, name: 'Sunday', shortName: 'Su', value: 'SU', medName: 'Sun' },
  { id: 1, name: 'Monday', shortName: 'Mo', value: 'MO', medName: 'Mon' },
  { id: 2, name: 'Tuesday', shortName: 'Tu', value: 'TU', medName: 'Tue' },
  { id: 3, name: 'Wednesday', shortName: 'We', value: 'WE', medName: 'Wed' },
  { id: 4, name: 'Thursday', shortName: 'Th', value: 'TH', medName: 'Thu' },
  { id: 5, name: 'Friday', shortName: 'Fr', value: 'FR', medName: 'Fri' },
  { id: 6, name: 'Saturday', shortName: 'Sa', value: 'SA', medName: 'Sat' },
];
